/**
 * Angular import.
 */
import { Component, ChangeDetectionStrategy, Input, OnInit, OnDestroy } from '@angular/core';

/**
 * Import API service.
 */
import { GetService } from '../../dataservices/get.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
/**
 * Import Language service.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
/**
 * Import Date formatter
 */
import { CustomDateFormatter } from './calender-custom-date.provider';
import { startOfDay, addDays, isSameMonth } from 'date-fns';
/**
 * Import angular calendar
 */
import { CalendarEvent, CalendarDateFormatter, CalendarView } from 'angular-calendar';
/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
/**
 * Import interface.
 */
import { CalenderDot } from './model/calenderDots.model';
import { MeetingList } from './model/calenderList.model';
import { ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME } from 'src/app/constants/app.constants';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Calender event component.
 */
@Component({
  selector: 'app-calender-event',
  templateUrl: './calender-event.component.html',
  styleUrls: ['./calender-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }
  ]
})

export class CalenderEventComponent implements OnInit, OnDestroy {

  /**
   * From where this component is getting called.
   */
  @Input() callingfrom;

  public month = 8;

  public year = 2019;

  public day = '';

  public view: CalendarView = CalendarView.Month;

  public CalendarView = CalendarView;

  public modalData: {
    action: string;
    event: CalendarEvent;
  };

  public viewDate = new Date();

  public is_true = true;

  public dt = new Date();

  public calender_list_data: MeetingList[];

  public color_code: CalenderDot[];

  public width = 0;

  public activeDayIsOpen = true;

  public refresh = new Subject();

  public events: CalendarEvent[] = [];
  /**
   * Used to load list by product type
   */
  public productType = 0;
  /**
   * Used to show list for
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public savedDate: any;
  /**
   * Used to load calendar or not
   */
  public isLoadedcalender = false;
  /**
   * Subscribe/Unsubscribe calender event list.
   */
  public calenderListSubscription: Subscription;
  /**
   * Subscribe/Unsubscribe calender dots.
   */
  public calenderDotsSubscription: Subscription;
  /**
   * Clicked on next month.
   */
  public isNextMonth = false;
  /**
   * Calendar offset.
   */
  public calendarListOffset = 1;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  constructor(public dss: DataStorageService,
              public fcs: FunCollectionService,
              private getSer: GetService,
              public mls: NewLanguageService,
              private analyticSdk: Analytics) {
    const dt = new Date();
    this.month = (dt.getMonth()) + 1;
  }

  /**
   * Load the component
   */
  ngOnInit(): void {
    this.dss.calenderTitle.next(this.productType);
    this.dss.cal_selected_day_month_year.month = this.dt.getMonth() + 1;
    this.dss.cal_selected_day_month_year.day = this.dt.getDate();
    this.dss.cal_selected_day_month_year.year = this.dt.getFullYear();
    this.calendarListOffset = 1;
    this.getCalenderList();
    this.subscriptions.add(this.dss.onchange_calender_event_data.subscribe(data => {
      this.is_true = true;
      if (data.day === '') {
        this.activeDayIsOpen = false;
        this.is_true = false;
      }
    }));
  }
  /**
   * Get calendar full view events list
   */
  getCalenderList(): void {
    this.calender_list_data = [];
    this.color_code = [];
    if (this.isLoadedcalender === true) {
      this.viewDate.setDate(1);
      this.viewDate.setMonth(this.dss.cal_selected_day_month_year.month);
    } else {
      this.isLoadedcalender = true;
    }
    this.savedDate = new Date(this.dss.cal_selected_day_month_year.month +
      '/' + this.dss.cal_selected_day_month_year.day +
      '/' + this.dss.cal_selected_day_month_year.year);
    this.dss.calendarMonthDate = this.savedDate.getTime() / 1000;
    this.calenderListSubscription = this.getSer.getNewCalenderList(
      this.savedDate.getTime() / 1000, '', this.productType, 1, this.calendarListOffset).subscribe(data => {
        if (data['status'] === 1) {
          this.calender_list_data = data['data'].meetingList;
          this.dss.calendar_events_list.next(data);
          this.getCalenderCodes();
          if (this.month !== this.dss.cal_selected_day_month_year.month) {
            this.activeDayIsOpen = false;
          }

          if (this.isNextMonth) {
            this.dss.viewDate.setDate(1);
            this.activeDayIsOpen = true;
          }
        }
      });
  }

  /**
   * Get calendar color dots api.
   */
  getCalenderCodes(): void {
    this.calenderDotsSubscription = this.getSer.getCalenderColorCodes((this.dt.getTime() / 1000)).subscribe(data => {
      if (data['status'] === 1) {
        this.color_code = data['data'].calenderDots;
        this.getCalDots();
      }
    });
  }

  /**
   * Apply calendar color dots on calender.
   */
  getCalDots(): void {
    this.events = [];
    for (let i = 0; i < this.color_code.length; i++) {
      const dt = new Date(this.color_code[i].date);
      const edate = this.dss.cal_selected_day_month_year.month + '/' + dt.getDate() + '/' + dt.getFullYear();
      const datum = Date.parse(edate);
      const clr = {
        primary: this.color_code[i].color,
        secondary: this.color_code[i].color,
      };

      const t = {
        start: startOfDay(datum),
        end: addDays(edate, 0),
        title: '',
        color: clr,
      };
      let f = 0;
      for (let k = 0; k < this.events.length; k++) {
        if (this.events[k].start.toString() === t.start.toString() && this.events[k].color.primary === clr.primary) {
          f = 1;
          break;
        }
      }
      if (f === 0) {
        this.events.push(t);
      }
    }
    this.refresh.next(1);
  }

  /**
   * User click on calender day.
   */
  dayClicked({ date }: { date: Date; events: CalendarEvent[] }): void {
    this.calender_list_data = [];
    if (isSameMonth(date, this.dss.viewDate)) {
      this.dss.viewDate = date;
      this.savedDate = this.dss.viewDate;
      const x = {
        day: this.savedDate.getDate(),
        month: this.dss.cal_selected_day_month_year.month,
        year: this.dss.cal_selected_day_month_year.year
      };
      const filterData = { startTime: date.getTime(), endTime: '', productType: this.productType, onward: 1, offset: 1 };
      this.dss.onchange_calender_event_data.next(x);
      this.dss.onchange_calender_events_data.next(filterData);
      this.activeDayIsOpen = true;
    }
  }

  /**
   * handleEvent
   */
  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
  }

  /**
   * set View
   */
  setView(view: CalendarView): void {
    this.view = view;
  }

  /**
   * Next and previous month clicked.
   */
  closeOpenMonthViewDay(): void {
    this.viewDate.setDate(1);
    this.month = this.viewDate.getMonth() + 1;
    this.dss.cal_selected_day_month_year.month = this.dss.viewDate.getMonth() + 1;
    this.dss.cal_selected_day_month_year.year = this.dss.viewDate.getFullYear();
    this.dss.cal_selected_day_month_year.day = 1;
    this.dt = this.dss.viewDate;
    this.calendarListOffset = 1;
    this.getCalenderList();
    this.activeDayIsOpen = false;
    this.isNextMonth = true;
  }

  /**
   * Used to filter list according to product type.
   */
  onItemChange(value, eventProperty: string): void {
    if (eventProperty && this.fcs.currentScreename?.length > 0) {
      const actionOn = eventProperty.toUpperCase()+'_TAB';
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, this.fcs.currentScreename, CTA_TYPE.TAB, ACTION_TYPE.CLICK, actionOn,null);
    }
    const filterData = { startTime: this.savedDate, endTime: '', productType: value, onward: 1, offset: 1 };
    this.dss.onchange_calender_events_data.next(filterData);
    this.productType = value;
    this.dss.calenderTitle.next(this.productType);
  }

  /**
   * Unsubscribe subscribe data.
   */
  ngOnDestroy(): void {
    if (this.calenderListSubscription) {
      this.calenderListSubscription.unsubscribe();
    }
    if (this.calenderDotsSubscription) {
      this.calenderDotsSubscription.unsubscribe();
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
